import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
    //header-related styles
     row: {
        minWidth: '100%',
        width: 'fit-content',
        height: 'fit-content',
        borderBottom: `1px solid ${theme.colors.neutral['400']}`,
        background: `#fff`,
    },
    header: {
        "& > span": {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            wordBreak: 'break-all',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontFamily: 'Inter',
            fontSize: '1.1rem',
            fontWeight: '600',
        },
    },
    hoverHeader: {
        color: theme.colors.neutral['600'],
        cursor: 'pointer',
        "&:hover": {
            color: theme.colors.neutral['900'],
            "& > svg": {
                color: theme.colors.neutral['900'],
                stroke: `${theme.colors.neutral['900']} !important`,
            },
        },
    },
    // cell-related styles
    cell: {
        minWidth: 180,
        maxWidth: 180,
        minHeight: 60,
        maxHeight: 60,
        padding: '2px 10px',
    },
    narrowCell: {
        minWidth: 150,
        maxWidth: 150,
    },
    narrowerCell: {
        minWidth: 50,
        maxWidth: 50,
    },
    wideCell: {
        minWidth: 280,
        maxWidth: 280,
    },
    widerCell: {
        minWidth: 380,
        maxWidth: 380,
    },
    fullWidthCell: {
        minWidth: 0,
        maxWidth: 'unset !important',
        width: '100%',
    },
    hiddenCell: {
        display: 'none',
    },
    endCell: {
        minWidth: 4,
        maxWidth: 4,
        padding: 'unset',
    },
    customCell: {
        minWidth: 240,
        maxWidth: 240,
    },
    customNarrowCell: {
        minWidth: 20,
        maxWidth: 20,
    },
    // component-related styles
    label: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-all',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    sublabel: {
        fontWeight: '500',
        color: theme.colors.neutral['500'],
    },
    plainText: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-word',
        overflow: 'hidden',
        textOverflow:'ellipsis',
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        color: '#666666',
    },
    value: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: theme.colors.neutral['500'],
    },
    icon: {
        width: 24,
        height: 24,
    },
    icon28: {
        width: 28,
        height: 28,
    },
    checkBox: {
        padding: 'unset !important',
        marginRight: '4px !important',
        "& > svg": {
            width: '20px !important',
            height: '20px !important',
        }
    },
    url: {
        display: 'inline-block',
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        fontWeight: 500,
        textDecoration: 'none',
        color: theme.colors.neutral['600'],
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineClamp: 1,
        "&:hover": {
            textDecoration: 'none !important',
        },
    },
    modal: {
      position: 'relative',
      width: 400,
      height: 400,
    },
    wave: {
        borderRadius: '4px !important',
        height: '24px !important',
    },
    activity: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: theme.colors.neutral['600'],
    },
    person: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    clear: {
        minWidth: 'unset',
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 600,
        color: theme.palette.warning.dark,
        textTransform: 'none',
        "&:hover": {
            background: 'unset',
        }
    },
    sortHeaders: {
        minWidth: 'unset',
        paddingLeft: 'unset',
        fontFamily: 'Inter',
        fontSize: '1.1rem',
        fontWeight: '600',
        color: theme.colors.neutral['600'],
        textTransform: 'none',
        "&:hover": {
            background: 'unset',
        }
    },
}));

export default useStyles;